<template>
<div>外出探访</div>
</template>

<script>
export default {
  name: 'outVisit'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/outVisit.vue